import Burger from '../../burger/v1/burger'

export function Header_CoreInit(custom_options = []) {
  $(function() {
    $('header').each(function () {
      let self = $(this);

      var default_options = {
        burger_options: {
          onToggle: function() {
            if (self.burger.isExpanded) {
              $('body').addClass('--menu-open')
            } else {
              $('body').removeClass('--menu-open')
            }
          },
        },
        scrolling_offset: 100
      }
      var header_options = $.extend(true, default_options, custom_options)

      self.burger = new Burger('.burger', header_options.burger_options)

      /* Scrolling states */
      self.old_scroll_pos = $(window).scrollTop()
      self.checkScrollingPosition = function() {
        self.current_scroll_pos = $(window).scrollTop()
        if (self.current_scroll_pos < header_options.scrolling_offset) {
          $('body').addClass('header--top')
          $('body').removeClass('header--scroll-down')
          $('body').removeClass('header--scroll-up')
        } else {
          $('body').removeClass('header--top')
          if (self.old_scroll_pos < self.current_scroll_pos) {
            $('body').addClass('header--scroll-down')
            $('body').removeClass('header--scroll-up')
          } else {
            $('body').removeClass('header--scroll-down')
            $('body').addClass('header--scroll-up')
          }
        }
        self.old_scroll_pos = $(window).scrollTop()
      }
      self.checkScrollingPosition()
      $(window).scroll(function() {
        self.checkScrollingPosition()
      })
    })
  });
}
